import { GenericServiceBase } from "@/services/generic-service";

export interface FigurinhaResponse {
  id: string;
  url: string;
  naBiblioteca: boolean;
  usos: number;
  ultimoUso?: string | null;
  dataCriacao: string;
}

export interface BibliotecaFigurinhasResponse {
  biblioteca: FigurinhaResponse[];
  recentes: FigurinhaResponse[];
}

export class FigurinhasService extends GenericServiceBase {
  constructor() {
    super("figurinhas");
  }

  async listar(): Promise<BibliotecaFigurinhasResponse> {
    return (await this.f.get("/", undefined, {
      resolve404As: { biblioteca: [], recentes: [] },
      resolve404AsValue: true,
    })) as BibliotecaFigurinhasResponse;
  }

  /**
   * Adiciona uma figurinha à biblioteca a partir da URL da mensagem.
   * O download do arquivo é feito pelo servidor — o navegador nunca busca
   * essa URL, o que evita o bloqueio cross-origin do Chrome.
   */
  async adicionarPorUrl(url: string): Promise<FigurinhaResponse> {
    return (await this.f.post("/", { url })) as FigurinhaResponse;
  }

  async criarPorArquivo(file: File): Promise<FigurinhaResponse> {
    return (await this.f.post(
      "/upload",
      { file },
      { formdata: true, jsonPayload: false },
    )) as FigurinhaResponse;
  }

  async registrarUso(url: string): Promise<FigurinhaResponse> {
    return (await this.f.post("/uso", { url })) as FigurinhaResponse;
  }

  async remover(id: string): Promise<void> {
    return (await this.f.delete(`/${id}`)) as void;
  }
}
